enum LogLevel {
    ERROR,
    WARNING,
    INFO,
    DEBUG,
}

export default LogLevel;
